import { useNavigate } from 'react-router-dom'
import { History, FileText, Clock } from 'lucide-react'
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api'

export default function HistoryPage() {
  const navigate = useNavigate()

  const { data: history, isLoading } = useQuery({
    queryKey: ['history'],
    queryFn: () => apiClient.getHistory(),
  })

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="flex flex-col items-center gap-3">
          <div className="animate-spin rounded-full h-8 w-8 border-2 border-telegram-button/30 border-t-telegram-button" />
          <span className="text-sm text-telegram-hint">Загрузка...</span>
        </div>
      </div>
    )
  }

  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr)
    return date.toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
    })
  }

  return (
    <div className="history-page flex flex-col min-h-full">
      {/* Header */}
      <div className="history-hero px-5 pt-5 pb-3">
        <div className="flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-xl glass-icon flex items-center justify-center">
            <History size={18} className="text-telegram-button" />
          </div>
          <div>
            <h1 className="text-base font-bold">История</h1>
            {history && history.length > 0 && (
              <p className="text-xs text-telegram-hint">{history.length} просмотров</p>
            )}
          </div>
        </div>
      </div>

      {/* List */}
      <div className="history-content flex-1 px-3 pb-4">
        {history && history.length > 0 ? (
          <div className="space-y-2">
            {history.map((item, index) => (
              <button
                key={item.id}
                onClick={() => navigate(`/law/${item.law_code}/article/${item.node_id}`)}
                className="history-card glass-card w-full flex items-center gap-3 p-3 text-left glass-appear"
                style={{ animationDelay: `${index * 40}ms` }}
              >
                <div className="w-9 h-9 rounded-xl glass-icon flex items-center justify-center shrink-0 relative z-10">
                  <FileText size={15} className="text-telegram-button/70" />
                </div>
                <div className="flex-1 min-w-0 relative z-10">
                  <div className="text-sm font-medium leading-snug line-clamp-1">{item.title}</div>
                  <div className="flex items-center gap-2 mt-0.5">
                    <span className="text-[10px] font-medium uppercase tracking-wider text-telegram-button">{item.law_code}</span>
                    <span className="text-telegram-hint/30">|</span>
                    <span className="flex items-center gap-1 text-[10px] text-telegram-hint">
                      <Clock size={10} />
                      {formatDate(item.viewed_at)}
                    </span>
                  </div>
                </div>
              </button>
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-16 text-center">
            <div className="w-16 h-16 rounded-full glass-icon flex items-center justify-center mb-4">
              <History size={28} className="text-telegram-button/40" />
            </div>
            <p className="text-sm font-medium mb-1">Пока пусто</p>
            <p className="text-xs text-telegram-hint">Просмотренные статьи появятся здесь</p>
          </div>
        )}
      </div>
    </div>
  )
}
